var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tabs', {
    staticClass: "v-tabs--primary tab--block",
    attrs: {
      "hide-slider": "",
      "height": "auto"
    }
  }, [_c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/news/campaign"
    }
  }, [_vm._v("진행중인 캠페인")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/news/campaign/ended"
    }
  }, [_vm._v("완료된 캠페인")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }